import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideNotification: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleWideNotification"><Path fillRule="evenodd" clipRule="evenodd" d="M19 2C16.7909 2 15 3.79086 15 6C15 8.20914 16.7909 10 19 10C21.2091 10 23 8.20914 23 6C23 3.79086 21.2091 2 19 2Z" fill="currentColor"/><Path d="M13 5.99999C13 4.90713 13.2922 3.88252 13.8027 3L2.00195 3.00002V19.0358H8.65157L11.9939 21.8375L15.3757 19.0358L22.002 19.0357V11.1962C21.119 11.7074 20.0937 12 19 12C15.6863 12 13 9.3137 13 5.99999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWideNotification;
